import { useIsBaggageInPaxMobile } from "../utils/experiments/funnel/flights_funnel_baggage_in_pax_mobile_2.js";
import useUserAgent from "./useUserAgent.js";
export default function usePaxWithBaggages() {
    const { isMobile } = useUserAgent();
    const isBaggageInPaxMobile = useIsBaggageInPaxMobile();
    return {
        isPaxWithBaggages: isBaggageInPaxMobile() ? true : !isMobile
    };
}
